import { gql } from "@apollo/client";

export const GET_COMPATIBLE_EXTRAS = gql`
  query getCompatibleExtras($input: CompatibleExtrasInput!) {
    compatibleExtras(input: $input) {
      id
      name
      description
      price
      calculationRule
      translations {
        name
        description
        language
      }
      inputType
      ... on MandatoryExtra {
        mandatoryQuantity
      }
    }
  }
`;
